import { Skeleton } from "@mui/material";

export default function TextSkeleton({ width = 100 }: { width?: number | string }) {
	return <Skeleton variant="text" width={width} sx={{ display: "inline-block" }} />;
}
